<frontend-pull-refresh></frontend-pull-refresh>

<section class="px-3 pb-3">
  <ng-template #onlineReservationDisabledMsgTemplate>
    <div *ngIf="!onlineReservations && enabledServicesResources" class="danger">
      You must assign service to resource.
    </div>
    <div *ngIf="!enabledServicesResources" class="danger">
      You must enable and set up Services and Resources for this to work.
    </div>
  </ng-template>

  <div *ngIf="!isLocationOnBusinessPlan">
    <ngb-alert [dismissible]="false" class="text-center mt-3">
      The online {{reservationTitle}} feature is available only for the Business Plan. <a routerLink="/settings/location/billing" class="alert-link">{{ account.recurly?.trial === false ? 'Start a Business Plan' : 'Start a Free Trial'}}</a> {{account.recurly?.trial === false ? '' : 'of a Business Plan '}}to give it a try.
    </ngb-alert>
  </div>

  <h1 class="pt-3 mb-3">{{ reservationTitle | titlecase }} Options</h1>
  <form *ngIf="reservationOptionsForm" [formGroup]="reservationOptionsForm" (ngSubmit)="submit()">
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label class="lead col-form-label">Appointment label</label>
        <p>Label you want to use throughout the app for reservations/appointments.</p>
      </div>
      <div class="col-sm-7 col-md-6 col-lg-4 col-xl-3 mt-2">
        <frontend-dropdown-plain
          elementId="settings-displaylabel-reservation"
          formControlName="reservationLabel"
          name="reservationLabel"
          [items]="reservationLabelOptions"
        ></frontend-dropdown-plain>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="reservation-bookingsAllowedPerTimeSlot" class="lead col-form-label">
          Limit {{ location.displayOptions.labels.reservation_plural }} per time slot
        </label>
        <p>
          Ensure you don't get slammed by too many {{ location.displayOptions.labels.reservation_plural }} starting at the same time.
        </p>
      </div>
      <div class="col-sm-3 col-lg-2 mt-2" formGroupName="bookingsAllowedPerTimeSlot">
        <div class="mb-1">
          <label class="form-check-label">
            <input type="checkbox"
                   class="form-check-input"
                   id="reservation-bookingsAllowedPerTimeSlot"
                   formControlName="enabled"
                   name="bookingsAllowedPerTimeSlotEnabled">
            Enable
          </label>
        </div>
        <div class="mb-1" *ngIf="reservationOptionsForm.get('bookingsAllowedPerTimeSlot.enabled').value">
          <input type="number"
                 class="form-control"
                 formControlName="quantity"
                 [class.is-invalid]="reservationOptionsForm.get('bookingsAllowedPerTimeSlot').invalid && reservationOptionsForm.get('bookingsAllowedPerTimeSlot').touched"
                 name="bookingsAllowedPerTimeSlotQuantity">
        </div>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="parties-limiter" class="lead col-form-label">
          Waitlist: hours of upcoming {{ reservationsTitle }} to show
        </label>
        <p>Set the reservations option to only show upcoming reservations for next N hours on Waitlist tab.</p>
      </div>
      <div class="col-sm-3 col-lg-2 mt-2">
        <label class="form-group">
          <input type="number"
                 class="form-control"
                 id="parties-limiter"
                 min="0"
                 formControlName="partiesLimiter"
                 name="partiesLimiter">
          <control-messages [control]="reservationOptionsForm.get('partiesLimiter')"></control-messages>
        </label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="reservation-allowMultipleParties" class="lead col-form-label">
          Allow Multiple {{ location.displayOptions.labels.customer_plural | titlecase}} to Book a {{location.resourceSettings.label | titlecase}}
        </label>
        <p>
          If not checked, each booked {{ location.displayOptions.labels.customer }} will occupy an entire
          {{ location.resourceSettings.label || "resource" }}.
        </p>
      </div>
      <div class="col-sm-3 col-lg-2 mt-2">
        <label class="form-check-label">
          <input type="checkbox"
                 class="form-check-input"
                 id="reservation-allowMultipleParties"
                 formControlName="allowMultipleParties"
                 name="allowMultipleParties">
          Enable
        </label>
      </div>
    </div>
    <div class="row form-group" *ngIf="reservationOptionsForm.get('allowMultipleParties').value">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="reservation-partySizeForTimeSlots" class="lead col-form-label">
          Count each person in a group as 1 spot each
        </label>
        <p>
          If not checked, each group will count as 1 spot instead of each person.
        </p>
      </div>
      <div class="col-sm-3 col-lg-2 mt-2">
        <label class="form-check-label">
          <input type="checkbox"
                 class="form-check-input"
                 id="reservation-partySizeForTimeSlots"
                 formControlName="partySizeForTimeSlots"
                 name="partySizeForTimeSlots">Enable
        </label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label class="lead col-form-label">{{ location.resourceSettings.label }} Auto-Assignment Prioritization Method</label>
      </div>
      <div class="col-sm-7 col-md-6 col-lg-4 col-xl-3 mt-2">
        <frontend-dropdown
          elementId="settings-resource-allocation"
          formControlName="resourceAllocation"
          name="resourceAllocation"
          bindLabel="name"
          bindValue="value"
          [items]="resourcePrioritizationMethods"
        ></frontend-dropdown>
        <ng-container *ngTemplateOutlet="onlineReservationDisabledMsgTemplate"></ng-container>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="public-reservation-view" class="col-form-label lead">
          Online {{ location.displayOptions.labels.reservation_plural }}
        </label>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <div class="form-check">
          <div class="d-flex flex-row justify-content-start align-items-center">
            <label class="form-check-label">
              <input
                type="checkbox"
                class="form-check-input"
                id="public-reservation-view"
                name="onlineReservationsEnabled"
                [attr.disabled]="(isDisabledOnlineReservations || !onlineReservations) ? true : null"
                (ngModelChange)="allowToDisableOnlineReservation($event)"
                formControlName="onlineReservationsEnabled">Enable
            </label>

            <span *ngIf="reservationOptionsForm.get('onlineReservationsEnabled').value" style="overflow-wrap: anywhere" class="ml-1">
            (<a class="info-link" href="{{origin}}/p/book/add/{{location.publicUrl}}" target="_blank">{{origin}}/p/book/add/{{location.publicUrl}}</a>)
          </span>
          </div>
          <span *ngIf="isLocationOnBusinessPlan">
          <ng-container *ngTemplateOutlet="onlineReservationDisabledMsgTemplate"></ng-container>
        </span>
          <div *ngIf="isDisabledOnlineReservations && messagesContainLink" class="danger">
            You must remove the links from notifications page before disabling.
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group" formGroupName="cancellationPolicy" *ngIf="location.integrations?.stripe?.enabled">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label class="lead col-form-label">Cancellation Policy</label>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
      <span>
        Payments will be automatically refunded for {{location.displayOptions.labels.reservation_plural}} cancellations made before
        <select
          class="ml-1"
          formControlName="time">
        <option *ngFor="let option of cancellationTimeOptions" [value]="option" [innerText]="option"></option>
      </select>

      <select
        class="ml-1"
        formControlName="period">
        <option  *ngFor="let option of [cancellationPolicyPeriod.hours, cancellationPolicyPeriod.days]" [value]="option" [innerText]="option"></option>
      </select>
      </span>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-serving-tracking" class="lead col-form-label">Serving Tracking</label>
        <p>Track your {{ location.displayOptions.labels.customer_plural }} as you're serving. Assign them to a resource as you move them
          from your waitlist and get a real-time view of your operation.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <div class="form-check">
          <input id="settings-serving-tracking"
                 name="servingTracking"
                 type="checkbox"
                 [attr.disabled]="!onlineReservations ? true : null"
                 formControlName="servingTracking"> Enable
          <ng-container *ngTemplateOutlet="onlineReservationDisabledMsgTemplate"></ng-container>
        </div>
      </div>
    </div>

    <div *ngIf="reservationOptionsForm.get('onlineReservationsEnabled').value">
      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="reservation-bookingInterval" class="lead col-form-label">
            {{ reservationTitle | titlecase }} interval
          </label>
          <p>In minutes, how often are your openings? E.g., enter "15" if you want openings at 6:00, 6:15, 6:30, etc. The minimum value is 5.</p>
        </div>
        <div class="col-sm-3 col-lg-2 mt-2">
          <label class="form-group">
            <input type="number"
                   class="form-control"
                   id="reservation-bookingInterval"
                   min="5"
                   step="5"
                   formControlName="bookingInterval"
                   name="bookingInterval">
            <control-messages [control]="reservationOptionsForm.get('bookingInterval')"></control-messages>
          </label>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="booking-limiter" class="lead col-form-label">
            Max days for advance {{ location.displayOptions.labels.reservation_plural }}
          </label>
          <p>Set the maximum days in advance that online {{ location.displayOptions.labels.reservation_plural }} can be scheduled, where 0 means same-day reservations only.</p>
        </div>
        <div class="col-sm-3 col-lg-2 mt-2">
          <label class="form-group">
            <input type="number"
                   class="form-control"
                   id="booking-limiter"
                   min="0"
                   formControlName="bookingLimiter"
                   name="bookingLimiter">
            <control-messages [control]="reservationOptionsForm.get('bookingLimiter')"></control-messages>
          </label>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="minimum-minutes-advance-booking" class="lead col-form-label">Minimum minutes for advance {{ location.displayOptions.labels.reservation_plural }}</label>
          <p>Set the earliest time you would want to accept an online {{ location.displayOptions.labels.reservation }}, e.g., 5 minutes from now, 30 minutes from now, etc.</p>
        </div>
        <div class="col-sm-3 col-lg-2 mt-2">
          <label class="form-group">
            <input type="number"
                   class="form-control"
                   id="minimum-minutes-advance-booking"
                   min="0"
                   formControlName="bookingMinLimiter"
                   name="bookingMinLimiter">
            <control-messages [control]="reservationOptionsForm.get('bookingMinLimiter')"></control-messages>
          </label>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="party-size-limiter" class="lead col-form-label">
            Max {{location.displayOptions.labels.customer_plural}} per online {{location.displayOptions.labels.reservation}}
          </label>
          <p>Determined by the resource max capacity or this value, whichever is smaller.</p>
        </div>
        <div class="col-sm-3 col-lg-2 mt-2">
          <label class="form-group">
            <input type="number"
                   class="form-control"
                   id="party-size-limiter"
                   min="0"
                   formControlName="partySizeLimiter"
                   name="partySizeLimiter">
            <control-messages [control]="reservationOptionsForm.get('partySizeLimiter')"></control-messages>
          </label>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="reservation-resource" class="lead col-form-label">
            {{ location.resourceSettings.label || "Resource" | titlecase }} selection required
          </label>
          <p>Ask {{ location.displayOptions.labels.customer }} to select a {{ location.resourceSettings.label || "resource" }}
            when booking online.</p>
        </div>
        <div class="col-sm-3 col-lg-2 mt-2">
          <label class="form-check-label">
            <input type="checkbox"
                   class="form-check-input"
                   id="reservation-resource"
                   formControlName="resourceSelectionRequired"
                   name="resourceSelectionRequired"> Enable
          </label>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="reservation-size" class="lead col-form-label">Search by {{ location.displayOptions.labels.customer }}
            size
          </label>
          <p>
            Ask {{ location.displayOptions.labels.customer }} to enter {{ location.displayOptions.labels.customer }} size when
            booking online.
          </p>
        </div>
        <div class="col-sm-3 col-lg-2 mt-2">
          <label class="form-check-label">
            <input type="checkbox"
                   class="form-check-input"
                   id="reservation-size"
                   formControlName="sizeSelectionRequired"
                   name="sizeSelectionRequired">
            Enable
          </label>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="reservation-time-selection" class="lead col-form-label">Search by time</label>
          <p>Ask {{ location.displayOptions.labels.customer }} to enter their preferred time when searching for availability.</p>
        </div>
        <div class="col-sm-3 col-lg-2 mt-2">
          <label class="form-check-label">
            <input type="checkbox"
                   class="form-check-input"
                   id="reservation-time-selection"
                   formControlName="timeSelectionWhenBooking"
                   name="timeSelectionWhenBooking">
            Enable
          </label>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="settings-serving-tracking" class="lead col-form-label">Redirect Mode</label>
          <p>Enable this to redirect to your add bookings page after someone adds themselves</p>
        </div>
        <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
          <div class="form-check">
            <input id="settings-redirect-mode"
                   type="checkbox"
                   [attr.disabled]="!onlineReservations ? true : null"
                   formControlName="isRedirectModeEnabled"> Enable
            <ng-container *ngTemplateOutlet="onlineReservationDisabledMsgTemplate"></ng-container>
          </div>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="settings-party-notes-on-timeline" class="lead col-form-label">Display party notes in timeline view</label>
        </div>
        <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
          <div class="form-check">
            <input
              id="settings-party-notes-on-timeline"
              type="checkbox"
              formControlName="partyNotesOnTimeline"
            > Enable
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-sm-3 offset-sm-3 offset-md-2">
        <button class="btn btn-info"
                type="submit"
                angularticsCategory="settings"
                angulartics2On="click"
                angularticsAction="Save Reservation Settings"
                [disabled]="reservationOptionsForm.pristine || !reservationOptionsForm.valid">Save
        </button>
      </div>
    </div>
  </form>

</section>
